export default __webpack_public_path__ + "static/media/255.407e63df.jpg";